var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('span',{key:_vm.keyValue,staticClass:"message"},[_vm._v(_vm._s(_vm._f("capatilize")(_vm.commitments[_vm.i])))])])}
var staticRenderFns = []

export { render, staticRenderFns }